'use client';

import { useEffect, type ReactNode } from 'react';
import Clarity from '@microsoft/clarity';

export function ClarityProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    const projectId = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID;
    if (!projectId || process.env.NODE_ENV !== 'production') return;

    Clarity.init(projectId);
  }, []);

  return <>{children}</>;
}
